const get = (obj: any, path: string, defaultValue: any = undefined) => {
  return path.split('.')
    .reduce((acc, part) => acc && acc[part], obj) ?? defaultValue;
};

const set = (obj: any, path: string, value: any) => {
  const parts = path.split('.');
  const last = parts.pop();
  const target = parts.reduce((acc, part) => acc[part] = acc[part] || {}, obj);
  target[last] = value;
  return obj;
};

const clone = (obj: any) => Object.assign({}, obj);

const cloneDeep = (obj: any) => {
  if (obj === null || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(cloneDeep);
  const clonedObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clonedObj[key] = cloneDeep(obj[key]);
    }
  }
  return clonedObj;
};

const merge = (target: any, ...sources: any[]): any => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} });
        }
        merge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return merge(target, ...sources);
};

// Helper function to check if value is an object
const isObject = (item: any): boolean => {
  return (item && typeof item === 'object' && !Array.isArray(item));
};

const debounce = (fn: Function, wait: number) => {
  let timeout: any;
  return function executedFunction(...args: any[]) {
    const later = () => {
      clearTimeout(timeout);
      fn(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const throttle = (fn: Function, wait: number) => {
  let inThrottle: boolean;
  return function(...args: any[]) {
    if (!inThrottle) {
      fn.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, wait);
    }
  };
};

const isEqual = (value1: any, value2: any): boolean => {
  if (typeof value1 !== typeof value2) return false;
  if (typeof value1 !== 'object') return value1 === value2;
  if (Array.isArray(value1) !== Array.isArray(value2)) return false;
  const keys1 = Object.keys(value1);
  const keys2 = Object.keys(value2);
  if (keys1.length !== keys2.length) return false;
  return keys1.every(key => isEqual(value1[key], value2[key]));
};

export const LodashReplacements = {
  get,
  set,
  clone,
  cloneDeep,
  merge,
  debounce,
  throttle,
  isEqual
  // Add more as needed
};
